module.exports = __webpack_public_path__ + "static/media/comment.9d3b2433.svg";